import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import Swal from "sweetalert2";
import {MsalService} from "@azure/msal-angular";

@Injectable({
  providedIn: 'root'
})
export class SeguridadGuard implements CanActivate, CanActivateChild {

  constructor(private loginService: LoginService, private router: Router,   private msalService: MsalService) {}

  canActivateChild(): Observable<boolean> | Promise<boolean> | boolean {
    return this.loginService.validarTiempo();
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {

    let rol=localStorage.getItem('Role');
      if(rol=="Admin AUT")
      {
        return true;
      }
      else
      {
        Swal.fire({
          icon: "info",
          title: 'Permisos Insuficientes',
          text: "Debe de Iniciar Sesion con un Usuario Permitido"
        })
        this.msalService.logoutPopup().subscribe(resp =>
        {
          localStorage.clear();
          this.router.navigateByUrl('/login');
        });

      }

    return this.loginService.validarTiempo();
  }

}
